// extracted by mini-css-extract-plugin
export default {"title":"SubTitle_title__iS-7R","iconContainer":"SubTitle_iconContainer__Vbfob","subTitleContainer":"SubTitle_subTitleContainer__zxuYL"};